<template>
    <SubmitPanel v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import SubmitPanel from '@/components/event/SubmitPanel.vue';

export default {
    name: 'EventEditSubmit',
    components: { SubmitPanel },

    mounted() {
        // we emit a "valid" input value, as we need to indicate "everything ok" to the parent component:
        this.$emit('input', true);
    },
};
</script>
